<template>
  <v-row class="justify-center align-center text-center ma-0">
    <v-col
      cols="12"
      sm="6"
      md="6"
      class="justify-center align-center text-center"
    >
      <v-img
        class="white--text"
        aspect-ratio="2"
        src="@/assets/logo.png"
        contain
      >
      </v-img>
    </v-col>
    <v-col cols="12" sm="6" md="6" class="d-flex  flex-sm-row bgcolorlogin">
      <v-row class="justify-center align-start align-self-sm-center">
        <v-card color="#0A7EA5" class="login-card" elevation="0">
          <v-card-title primary-title class="login-title white--text">
            <h1>Login</h1>
          </v-card-title>
          <v-card-title class="login-title mt-n4" style="color:#ffffff">
            <h5>
              Don't have an account yet?
              <span
                class="ml-2"
                v-bind:style="{
                  color: '#ffffff',
                  fontWeight: '400 !important',
                  align: 'left',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }"
                @click="$router.push('/register-company')"
              >
                Register</span
              >
            </h5>
          </v-card-title>
          <v-card-text class="login-fields mt-8">
            <v-form @submit.prevent="submit">
              <v-row class="justify-left align-left text-left white--text">
                <v-col cols="12">
                  <h2
                    v-bind:style="{
                      color: '#ffffff',
                      fontWeight: '300 !important',
                    }"
                  >
                    Company Code
                  </h2>
                </v-col>
              </v-row>
              <v-row>
                <!--   label="Username" -->
                <v-text-field
                  name="company_code"
                  id="company_code"
                  v-model="account.company_code"
                  solo
                  hide-details
                />
              </v-row>

              <v-row class="justify-left align-left text-left white--text">
                <v-col cols="12">
                  <h2
                    v-bind:style="{
                      color: '#ffffff',
                      fontWeight: '300 !important',
                    }"
                  >
                    Username
                  </h2>
                </v-col>
              </v-row>
              <v-row>
                <!--   label="Username" -->
                <v-text-field
                  name="username"
                  id="username"
                  v-model="account.username"
                  solo
                  hide-details
                />
              </v-row>

              <v-row class="justify-left align-left text-left white--text mt-4">
                <v-col cols="12">
                  <h2
                    v-bind:style="{
                      color: '#ffffff',
                      fontWeight: '300 !important',
                    }"
                  >
                    Password
                  </h2>
                </v-col>
              </v-row>
              <v-row>
                <!--  label="Password" -->
                <v-text-field
                  name="password"
                  id="password"
                  v-model="account.password"
                  :append-icon="
                    isShowPassword ? 'visibility' : 'visibility_off'
                  "
                  @click:append="isShowPassword = !isShowPassword"
                  :type="isShowPassword ? 'text' : 'password'"
                  solo
                  hide-details
                  color="##757575"
                />
              </v-row>
              <!-- counter -->

              <v-row class="justify-center align-center text-center">
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  class="justify-left align-left text-left"
                >
                  <v-checkbox
                    v-model="account.remember_device"
                    class="white--text"
                    color="#ffffff"
                    dark
                    label="Remember this device"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  class="justify-right align-right text-right"
                >
                  <span
                    class="ml-2"
                    v-bind:style="{
                      color: '#ffffff',
                      fontWeight: '400 !important',
                      align: 'left',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }"
                    @click="forgotPassword()"
                    >Forgot Password?</span
                  >
                  <!-- <v-btn
                style="color:#254e58"
                text
                @click.prevent="forgotPassword()"
                >Forgot Password?</v-btn
              > -->
                </v-col>
              </v-row>

              <v-row class="px-3 pt-5">
                <v-btn
                  v-if="false"
                  text
                  @click.prevent="$router.push('/register')"
                  >Register</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn class="white--text" type="submit" block color="#7B96D4"
                  >Login</v-btn
                >
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-title
            class="login-title mt-n4"
            style="color: #ffffff; display: flex; justify-content: flex-end; padding-top: 120px;"
          >
            <h5>
              Want more information?
              <span
                class="ml-2"
                v-bind:style="{
                  color: '#ffffff',
                  fontWeight: '400 !important',
                  align: 'left',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }"
                @click="previewnoticefilepdf()"
              >
                Download Brochure</span
              >
            </h5>
          </v-card-title>

          <div
            class="login-title mt-n10"
            style="color: #ffffff; display: flex; justify-content: flex-start;"
          >
            <h4>
              <span
                class="ml-6"
                v-bind:style="{
                  color: '#ffffff',
                  fontWeight: '400 !important',
                  align: 'left',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }"
                @click="previewprivacypolicyfilepdf()"
                >Privacy Policy</span
              >
            </h4>
          </div>
        </v-card>
      </v-row>
    </v-col>

    <!-- <v-container style="margin-top: 5%;"> -->
    <!-- <v-row align="center" justify="center" class="pt-20">
      <v-card class="login-card" color="#F1F4F7">
        <v-img
          class="white--text align-end"
          aspect-ratio="2.5"
          src="@/assets/logo.png"
          contain
        >
        </v-img>
        <v-card-title primary-title class="login-title">
          Login
        </v-card-title>
        <v-card-text class="login-fields">
          <v-form @submit.prevent="submit">
            <v-text-field
              name="username"
              label="Username"
              id="username"
              v-model="account.username"
            />

            <v-text-field
              name="password"
              label="Password"
              id="password"
              v-model="account.password"
              :append-icon="isShowPassword ? 'visibility' : 'visibility_off'"
              @click:append="isShowPassword = !isShowPassword"
              :type="isShowPassword ? 'text' : 'password'"
              counter
            />

            <v-row>
              <v-btn
                style="color:#254e58"
                text
                @click.prevent="forgotPassword()"
                >Forgot Password ?</v-btn
              >
            </v-row>

            <v-row class="justify-space-between px-3 pt-5">
              <v-btn
                v-if="false"
                text
                @click.prevent="$router.push('/register')"
                >Register</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn type="submit" color="#42A5F5">Login</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row> -->

    <!-- <notifications group="auth" position="center" /> -->

    <v-dialog v-model="dialog" persistent max-width="290">
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Open Dialog
        </v-btn>
      </template> -->
      <v-card>
        <v-card-title class="text-h5">
          Select Company
        </v-card-title>
        <v-row>
          <v-col class="pa-5" cols="12" sm="12" md="12">
            <v-select
              :items="companyAll"
              label="Company"
              item-text="name"
              item-value="id"
              outlined
              @change="changeCompany"
            ></v-select>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="goWeb">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ⭐ ใหม่ — dialog กรอก OTP (SMS) หลัง login สำเร็จเบื้องต้นแต่ยังไม่ผ่าน trusted device -->
    <v-dialog
      v-model="otpDialog"
      persistent
      max-width="400"
      content-class="otp-dialog"
    >
      <v-card>
        <v-card-title class="justify-center flex-column pt-6">
          <div class="text-h6 font-weight-bold">Two-factor authentication</div>
          <div class="text-body-2 grey--text mt-2 text-center">
            We've sent a 6-digit code via SMS to<br />
            <strong>{{ phoneMasked }}</strong>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-2">
            <v-col cols="10">
              <v-otp-input
                length="6"
                v-model="otpCode"
                :disabled="otpExpired"
              ></v-otp-input>
              <!-- ถ้าเวอร์ชัน Vuetify ที่ใช้ไม่มี v-otp-input ให้ใช้ input ธรรมดาแทน -->
              <!-- <v-text-field v-model="otpCode" label="Enter 6-digit code" maxlength="6" outlined /> -->
            </v-col>
          </v-row>

          <!-- ⭐ ใหม่ — นับถอยหลัง 5 นาที เหมือน forgot password -->
          <div class="text-center mt-1">
            <span v-if="!otpExpired" class="text-caption grey--text">
              Code expires in
              <strong :class="{ 'red--text': otpCountdown <= 30 }">{{
                otpCountdownDisplay
              }}</strong>
            </span>
            <span v-else class="text-caption red--text font-weight-medium">
              Code expired. Please request a new one.
            </span>
          </div>

          <div class="text-center mt-2">
            <span
              style="cursor:pointer; text-decoration:underline; color:#7B96D4"
              @click="resendOtp"
            >
              Resend code
            </span>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn text @click="cancelOtp">Cancel</v-btn>
          <v-btn
            color="#7B96D4"
            class="white--text"
            @click="submitOtp"
            :disabled="otpCode.length !== 6 || otpExpired"
          >
            Verify
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <!-- </v-container> -->
  </v-row>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server, POAUrl } from "../services/constants";

export default {
  async mounted() {
    await this.loadCompany();

    this.$hideLoader();
    this.$store.state.navMenu = false;
    this.$store.state.isLogged = false;
    const userId = localStorage.getItem(server.USER_ID);

    // console.log("Login mounted : " + api.isLoggedIn());
    // console.log("Login mounted : " + userId);
    if (userId && api.isLoggedIn()) {
      this.$router.push("/");
    }
  },
  // ⭐ ใหม่ — เคลียร์ timer กันหน่วยความจำรั่วถ้าออกจากหน้านี้ระหว่างที่ dialog OTP เปิดอยู่
  beforeDestroy() {
    this.stopOtpCountdown();
  },
  components: {
    SuccessDialog,
  },
  data() {
    return {
      isShowPassword: false,
      account: {
        company_code: "",
        username: "",
        password: "",
        keep_me_logged_in: false,
        remember_device: true, // ⭐ ใหม่ — ค่าเริ่มต้นติ๊กไว้ เหมือนใน mockup
      },
      fullPage: true,
      dialog: false,
      companyAll: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",

      // ⭐ ใหม่ — state สำหรับ OTP dialog (SMS)
      otpDialog: false,
      otpCode: "",
      phoneMasked: "",
      otpCompanyCode: "",
      otpUsername: "",
      otpToken: "",
      otpRefCode: "",
      otpUserId: null,

      // ⭐ ใหม่ — นับถอยหลัง 5 นาที (300 วินาที) เหมือนหน้า forgot password
      otpCountdown: 300,
      otpCountdownTimer: null,
      otpExpired: false,
    };
  },

  computed: {
    // ⭐ ใหม่ — แปลงวินาทีที่เหลือเป็น mm:ss
    otpCountdownDisplay() {
      const m = Math.floor(this.otpCountdown / 60)
        .toString()
        .padStart(2, "0");
      const s = (this.otpCountdown % 60).toString().padStart(2, "0");
      return `${m}:${s}`;
    },
  },

  methods: {
    async previewnoticefilepdf(file_name) {
      let pdf_newTab = window.open(`${POAUrl}/file_login/DTime_Poster.pdf`);

      return;
    },
    async previewprivacypolicyfilepdf(file_name) {
      // let pdf_newTab = window.open(
      //       `${POAUrl}/file_login/DCM_Privacy_Policy_(ENG).pdf`
      //   );
      window.open(`http://${window.location.host}/privacy-policy`);

      return;
    },
    goWeb() {
      this.dialog = false;
      this.$router.push("/dashboard");
    },
    changeCompany(val) {
      // console.log("changeCompany:", val);
      localStorage.setItem(server.COMPANYID, val);
    },
    async loadCompany() {
      var result = await api.getAllCompany();
      this.companyAll = result.data;
    },

    // ⭐ ใหม่ — เริ่ม/รีเซ็ตนับถอยหลัง 5 นาที (เรียกตอนเปิด dialog OTP ครั้งแรก และตอนกด Resend code)
    startOtpCountdown() {
      this.stopOtpCountdown();
      this.otpCountdown = 300; // 5 นาที เหมือน forgot password
      this.otpExpired = false;
      this.otpCountdownTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--;
        } else {
          this.stopOtpCountdown();
          this.otpExpired = true;
        }
      }, 1000);
    },
    // ⭐ ใหม่ — หยุด timer (ตอนปิด dialog / verify สำเร็จ / ออกจากหน้า)
    stopOtpCountdown() {
      if (this.otpCountdownTimer) {
        clearInterval(this.otpCountdownTimer);
        this.otpCountdownTimer = null;
      }
    },

    submit() {
      if (
        !this.account?.company_code?.trim() ||
        !this.account?.username?.trim() ||
        !this.account?.password?.trim()
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Login Fail",
          "Incorrect Company Code or Username or Password",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.$showLoader();

      this.$store
        .dispatch({
          type: "doLogin",
          company_code: this.account.company_code,
          username: this.account.username,
          password: this.account.password,
        })
        .then((val) => {
          this.$hideLoader();

          // ⭐ ใหม่ — backend บอกว่าต้องยืนยัน OTP (SMS) ก่อน
          if (val && val.require_otp) {
            this.otpUserId = val.user_id;
            this.otpCompanyCode = val.company_code;
            this.otpUsername = val.username || this.account.username;
            this.otpToken = val.otp_token;
            this.otpRefCode = val.ref_code;
            this.phoneMasked = val.phone_masked;
            this.otpCode = "";
            this.otpDialog = true;
            this.startOtpCountdown(); // ⭐ ใหม่ — เริ่มนับถอยหลัง 5 นาทีทันทีที่เปิด dialog
            return;
          }

          if (this.$store.getters["isLogin"]) {
            if (localStorage.getItem(server.ROLE) == "ADMIN") {
              this.dialog = true;
            } else {
              this.$router.push("/dashboard");
            }
          }
        })
        .catch((error) => {
          this.$hideLoader();

          if (
            error.response &&
            error.response.data &&
            error.response.data.success === false
          ) {
            // แกะเอาข้อความ "ชื่อผู้ใช้งาน หรือรหัสผ่านไม่ถูกต้อง" ที่หลังบ้านส่งมาแสดง
            const alertMessage =
              error.response.data.message ||
              "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง";

            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "เข้าสู่ระบบไม่สำเร็จ",
              alertMessage,
              "text-h5 red--text text-center",
            );
            return;
          } else if (error.response) {
            if (error.response.status === 503 && error.response.data.ip_error) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "ไม่สามารถเข้าใช้งานได้",
                error.response.data.ip_error,
                "text-h5 red--text text-center",
              );
              return;
            } else {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "เกิดข้อผิดพลาดจากระบบ",
                "เซิร์ฟเวอร์ขัดข้องชั่วคราว กรุณาติดต่อผู้ดูแลระบบ",
                "text-h5 red--text text-center",
              );
              return;
            }
          }

          // 💡 3. เคสเน็ตหลุด ยิงไปหาหลังบ้านไม่ได้เลย
          else {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "การเชื่อมต่อล้มเหลว",
              "ไม่สามารถเชื่อมต่อเครือข่ายได้ กรุณาตรวจสอบอินเทอร์เน็ตของคุณ",
              "text-h5 orange--text text-center",
            );
            return;
          }
        });
    },

    // ⭐ ใหม่ — ยืนยัน OTP (SMS) ขั้นตอนที่ 2 ของ login
    async submitOtp() {
      this.$showLoader();
      try {
        const ok = await this.$store.dispatch({
          type: "completeLoginAfterOtp",
          company_code: this.otpCompanyCode,
          username: this.otpUsername,
          otp_token: this.otpToken,
          ref_code: this.otpRefCode,
          otp_code: this.otpCode,
          remember_device: this.account.remember_device,
        });
        this.$hideLoader();

        if (ok) {
          this.stopOtpCountdown(); // ⭐ ใหม่ — verify ผ่านแล้วเลิกนับถอยหลัง
          this.otpDialog = false;
          if (localStorage.getItem(server.ROLE) == "ADMIN") {
            this.dialog = true;
          } else {
            this.$router.push("/dashboard");
          }
        }
      } catch (error) {
        this.$hideLoader();
        const alertMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่";
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ยืนยัน OTP ไม่สำเร็จ",
          alertMessage,
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ ใหม่ — กด "Resend code"
    async resendOtp() {
      try {
        const res = await api.resendLoginOtp({ user_id: this.otpUserId });
        this.otpCode = "";
        this.otpToken = res.otp_token;
        this.otpRefCode = res.ref_code;
        this.startOtpCountdown(); // ⭐ ใหม่ — ส่งรหัสใหม่แล้ว รีเซ็ตนับถอยหลังเป็น 5 นาทีใหม่
      } catch (error) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ส่งรหัสไม่สำเร็จ",
          "กรุณาลองใหม่อีกครั้ง",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ ใหม่ — ปิด dialog OTP
    cancelOtp() {
      this.stopOtpCountdown(); // ⭐ ใหม่
      this.otpDialog = false;
      this.otpCode = "";
    },

    forgotPassword() {
      // alert("Forgot Password");
      this.$router.push("/forgot-password");
    },
    onCancel() {
      // console.log("User cancelled the loader.");
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
</script>

<style scoped>
.login-card {
  width: 100%;
  padding: 1.5rem 0;
}

.login-title {
  justify-content: center;
}

.login-fields {
  width: 70%;
  margin: auto;
}

/* @media only screen and (max-width: 991px) {
  .login-card {
    width: 80%;
  }
  .login-fields {
    width: 90%;
  }
} */
.bgcolorlogin {
  background-color: #0a7ea5;
  height: 100vh;
  /* align-content: center; */
}

.heightpage {
  height: 100%;
}
</style>
